// React core components
import React from "react";

// @mui Material components
import {
    Typography,
    TextField,
    Modal,
    Autocomplete,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";


const CoursesModal = ({ open, handleClose, couponName, setCouponName, couponEmail, setCouponEmail, selectedCourses, setSelectedCourses,
    allCourses, handleEditCoupon, couponError, currentMode, MODE }) => {

    const _handleSave = () => {
        handleEditCoupon();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    outline: "none",
                    minWidth: "50vw",
                }}
            >
                <Typography variant="h6" >
                    {currentMode === MODE.ADD && "Add New Coupon"}
                    {currentMode === MODE.EDIT && "Manage User"}
                </Typography>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Name"
                    value={couponName}
                    disabled={currentMode == MODE.EDIT}
                    onChange={(e) => { setCouponName(e.target.value) }}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Email"
                    value={couponEmail}
                    disabled={currentMode == MODE.EDIT}
                    onChange={(e) => { setCouponEmail(e.target.value) }}
                />
                {couponError && (
                    <Typography variant="caption" color="error">
                        {couponError}
                    </Typography>
                )}
                <Autocomplete
                    multiple
                    options={allCourses}
                    getOptionLabel={(option) => option.app_name}
                    value={selectedCourses}
                    onChange={(event, newValue) => {
                        // filter out duplcates
                        let arrayValues = newValue.filter(
                            (value, index, self) =>
                                index ===
                                self.findIndex(
                                    (t) => t.id === value.id && t.app_name === value.app_name
                                )
                        );
                        setSelectedCourses(arrayValues);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Selected Courses"
                            margin="normal"
                        />
                    )}
                />

                <MDBox mt={2} display="flex" justifyContent="flex-end">
                    <MDButton
                        onClick={handleClose}
                        color="secondary"
                        style={{ marginRight: "10px" }}
                    >
                        Cancel
                    </MDButton>
                    <MDButton
                        color="success"
                        onClick={() => { _handleSave() }}
                    >
                        Save
                    </MDButton>
                </MDBox>
            </div>
        </Modal>
    );
};

export default CoursesModal; // Ensure this line exists
